import { Box, Image, Text, Flex, Heading, Grid } from '@chakra-ui/react';
import Wrapper from '../../../common/Wrapper';
import { contentImg } from '../../../../assets/exports';
import { bizflexFeatures } from '../../../common/constants';

const NinthLayer = () => {
  return (
    <Wrapper>
      <Flex
        pos="relative"
        justifyContent="space-between"
        gap="2rem"
        flexDir={['column-reverse', 'column-reverse', 'row', 'row']}
        mt={{ base: '100px', md: '149px' }}
        pt={{ base: '56px', md: '120px' }}
        pb={{ base: '56px', md: '120px' }}
        bgColor="#7B47CC"
        color="#ffff"
        px={['20px', '50px', '70px', '90px']}
      >
        <Box>
          <Image h="full" w="full" src={contentImg} />
        </Box>
        <Box>
          <Text color="#FF9D16" fontWeight={600} fontSize="20px">
            FEATURES
          </Text>
          <Heading
            pt="12px"
            pb={{ base: '20px', md: '34px' }}
            fontSize={['24px', '32px', '40px']}
          >
            Some of Bizflex Features
          </Heading>
          <Flex
            flexDir="column"
            gap="40px"
            bg="#1A202C"
            borderRadius="12px"
            p="2rem"
            pos="relative"
          >
            {bizflexFeatures.map((item, i) => (
              <Flex alignItems="center" gap="9px" key={i}>
                <Box
                  position="relative"
                  w={{ base: '30px', md: '50px' }}
                  h={{ base: '30px', md: '50px' }}
                  bg={i > 1 ? '#fff' : '#FF9D16'}
                  color={i > 1 ? '#1A202C' : '#fff'}
                  rounded="full"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  zIndex={1}
                >
                  <Text
                    fontWeight={600}
                    fontSize={{ base: '14px', md: '24px' }}
                  >
                    {item.id}
                  </Text>
                  {i < bizflexFeatures.length - 1 && (
                    <Box
                      pos="absolute"
                      h={{ base: '40px', md: '60px' }}
                      bg={i > 1 ? '#E2E8F0' : '#FF9D16'}
                      border={i > 1 ? '1px dashed #ffff' : '1px dashed #FF9D16'}
                      top="100%"
                      left="50%"
                      transform="translateX(-50%)"
                    />
                  )}
                </Box>
                <Text fontSize={{ base: '14px', md: '20px' }}>
                  {item?.text}
                </Text>
              </Flex>
            ))}
          </Flex>
        </Box>
      </Flex>
    </Wrapper>
  );
};
export default NinthLayer;
